import React from "react";
import { Navigate } from "react-router-dom";

import { useAppSelector } from "../../redux/hooks";
import { AuthStatus, getAuthStatus } from "../../redux/reducers/auth";
import { getRoles, getUserStatus, UserStatus } from "../../redux/reducers/user";
import LoadingSpinner from "../LoadingSpinner";

type Props = {
  component: React.FC;
  role?: string | Array<string>;
};

const RequireAuth: React.FC<Props> = ({
  component: Component,
  role: role,
  ...rest
}) => {
  // The following two guarantee that the user is authorized & that the user's data has finished loading. Check for both is only neccessary here, in other places checking for one or the other should be sufficient.
  const auth_status = useAppSelector(getAuthStatus);
  const user_status = useAppSelector(getUserStatus);
  const roles = useAppSelector(getRoles);

  switch (auth_status) {
    case AuthStatus.Authenticated:
      if (user_status == UserStatus.Complete) {
        if (role == undefined) {
          return <Component {...rest} />;
        } else if (roles?.some((r) => role.includes(r))) {
          return <Component {...rest} />;
        } else {
          return <Navigate to="/login" replace />;
        }
      } else {
        return <LoadingSpinner space={6} />;
      }
    case AuthStatus.Loading:
      return <LoadingSpinner space={6} />;
    default:
      return <Navigate to="/login" replace />;
  }
};

export default RequireAuth;
